/* Reveal on scroll */
const io=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12});
document.querySelectorAll('.rv').forEach(el=>io.observe(el));

/* ===== GOOGLE SHEETS — LEADS & METRICS =====
   1. Follow GOOGLE-SHEETS-SETUP.md to deploy the Apps Script Web App.
   2. Paste the Web App URL between the quotes below.               */
const SHEET_ENDPOINT = 'https://script.google.com/macros/s/AKfycbw9SiAGKbwsEoKZOvtKFKcf_BzG-QdBRo40C5DmE9ZuBreicqWXce0uty2Dk1KC2UC0/exec';

const deviceType = () => window.innerWidth <= 640 ? 'mobile' : 'desktop';
function sendToSheet(payload){
  if(!SHEET_ENDPOINT.startsWith('http')) return;
  try{
    fetch(SHEET_ENDPOINT,{method:'POST',mode:'no-cors',
      headers:{'Content-Type':'text/plain'},
      body:JSON.stringify(Object.assign({device:deviceType(),page:location.href},payload))});
  }catch(e){}
}
const track=(event,detail)=>sendToSheet({type:'event',event,detail:detail||''});

/* Auto-tracked metrics */
track('page_view');
document.querySelectorAll('a[href^="tel:"]').forEach(a=>a.addEventListener('click',()=>track('call_click')));
document.querySelectorAll('a[href*="wa.me"]').forEach(a=>a.addEventListener('click',()=>track('whatsapp_click')));
document.querySelectorAll('.sticky-cta a, .quote-cta').forEach(a=>a.addEventListener('click',()=>track('cta_click')));

/* Journey timeline sequence */
const sio=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('go');sio.unobserve(e.target)}})},{threshold:.25});
document.querySelectorAll('.steps').forEach(el=>sio.observe(el));

/* Sticky mobile CTA — appears only after the lead form has been scrolled past */
const stickyCta=document.querySelector('.sticky-cta'),formCard=document.querySelector('.form-card');
function toggleSticky(){
  const r=formCard.getBoundingClientRect();
  stickyCta.classList.toggle('show', r.bottom<0);
}
window.addEventListener('scroll',toggleSticky,{passive:true});
toggleSticky();

/* Count-up animation for highlight numbers */
const fmt=n=>n.toLocaleString('en-IN');
const cio=new IntersectionObserver(es=>{es.forEach(e=>{
  if(!e.isIntersecting)return;
  const el=e.target,target=+el.dataset.count,suf=el.dataset.suffix||'';
  const dur=1400,t0=performance.now();
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce){el.textContent=fmt(target)+suf;cio.unobserve(el);return}
  (function tick(t){
    const p=Math.min((t-t0)/dur,1),ease=1-Math.pow(1-p,3);
    el.textContent=fmt(Math.round(target*ease))+suf;
    if(p<1)requestAnimationFrame(tick);
  })(t0);
  cio.unobserve(el);
})},{threshold:.5});
document.querySelectorAll('.num[data-count]').forEach(el=>cio.observe(el));

/* Video testimonials — opens YouTube embed or .mp4 in a modal.
   If a card's data-video is empty, it opens your Instagram instead. */
const vmodal=document.getElementById('vmodal'),vbox=document.getElementById('vbox');
document.querySelectorAll('.vcard').forEach(card=>{
  card.addEventListener('click',()=>{
    const src=card.dataset.video.trim();
    track('video_play', src||'instagram');
    if(!src){window.open('https://www.instagram.com/weddingtales_matrimony/','_blank');return}
    if(src.endsWith('.mp4')||src.startsWith('data:video')){
      vbox.classList.add('vert');
      vbox.innerHTML=`<video src="${src}" controls autoplay playsinline></video>`;
      vbox.querySelector('video').onerror=function(){
        vbox.classList.remove('vert');
        vbox.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;padding:30px;text-align:center;color:#bfb49a;font-size:.95rem">Video unavailable — please make sure the \u201cvideos\u201d folder is uploaded next to this page on your hosting.</div>';
      };
    }else{
      vbox.classList.remove('vert');
      vbox.innerHTML=`<iframe src="${src}?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    }
    vmodal.classList.add('open');
  });
});
vmodal.addEventListener('click',e=>{
  if(e.target===vmodal||e.target.classList.contains('close')){
    vmodal.classList.remove('open');vbox.innerHTML='';
  }
});

/* Lead form → WhatsApp (works without a backend).
   To send leads to your CRM instead, replace the body of submitLead()
   with a fetch('YOUR_CRM_ENDPOINT', {method:'POST', body: data}). */
document.getElementById('leadForm').addEventListener('submit',function(ev){
  ev.preventDefault();
  const f=ev.target;
  if(!f.reportValidity())return;
  const name=f.name.value.trim(),
        phone=f.phone.value.trim(),
        who=f.for.value, city=f.city.value,
        prof=f.prof.value.trim()||'—',
        income=f.income.value.trim();

  /* Send lead to Google Sheet */
  sendToSheet({type:'lead',name,phone,who,city,prof,income});

  /* META PIXEL: fire the Lead event here, e.g. fbq('track','Lead'); */

  /* Thank-you popup (no WhatsApp navigation) */
  document.getElementById('tyname').textContent=name.split(' ')[0]||'Friend';
  document.getElementById('tymodal').classList.add('open');
  f.reset();
});
document.getElementById('tyok').addEventListener('click',()=>document.getElementById('tymodal').classList.remove('open'));
document.getElementById('tymodal').addEventListener('click',e=>{if(e.target.id==='tymodal')e.target.classList.remove('open')});